import { Component, OnInit } from "@angular/core";
import { RestService } from "../rest.service";
import { catchError, retry } from "rxjs/operators";
import { SystemUtils } from "../utils/system.utils";

@Component({
  selector: "app-job-permission",
  templateUrl: "./job-permission.component.html",
  styleUrls: ["./job-permission.component.css"]
})
export class JobPermissionComponent implements OnInit {
  isFailure: boolean = false;
  failureMessage: any = "";
  isSuccess: boolean = false;
  successMessage: any = "";

  systemList: any = [];
  environment_name: any = [];

  constructor(private _restService: RestService) {}

  ngOnInit() {
    this._restService
      .getsystemAccess('90', '1')
      .pipe(
        catchError(e => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.systemList = f.systemAccess),
          (SystemUtils.sortSystemAccess(this.systemList)),
          (console.log("Lists --->", this.systemList)),
          (this.environment_name = this.systemList[0].envList),
          console.log("NMADNBbd", this.systemList[0].envList)
        )
      );
  }
}
